import useAnimated, {
  AnimatedProvider,
  useAnimatedUpdater,
  AnimatedContextUpdater,
} from './AnimatedProvider';

export { AnimatedProvider, useAnimatedUpdater, AnimatedContextUpdater };

export default useAnimated;
